import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import { firebaseConfig } from './config'

export const app = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
export default db;


export const auth = firebase.auth();
export const firestore = firebase.firestore();


const GoogleProvider = new firebase.auth.GoogleAuthProvider();
GoogleProvider.setCustomParameters({ prompt: 'select_account' })
export const signInWithGoogle = () => auth.signInWithPopup(GoogleProvider);

export const handleUserProfile = async ({userAuth, additionalData}) =>{
	if(!userAuth) return;
	const { uid } = userAuth;

	const userRef = firestore.doc(`users/${uid}`);
	const snapshot = await userRef.get();

	if(!snapshot.exists){
		const { displayName, 
			address,
			address2,
			city,
			state,
			zip,
			phone,
			email, 
			userRoles,
			subscribed } = userAuth;
		const timestamp = new Date();


		try{
			await userRef.set({
				displayName,
				address,
				address2,
				city,
				state,
				zip,
				phone,
				email,
				userRoles,
				subscribed,
				createdDate: timestamp,
				...additionalData
				
			});
		}catch(err){
			//console.log(err)
		}
	}
	return userRef;

};


export const getCurrentUser = () => {
	return new Promise((resolve, reject) => {
	  const unsubscribe = auth.onAuthStateChanged(userAuth => {
		unsubscribe();
		resolve(userAuth);
	  }, reject);
	})
  }